import { Institution, Representative, Student } from 'domain/entities/representative'

export const InstitutionEmpty = {
  promotionId: '',
  institutionId: '',
  name: '',
  role: '',
}

export type InitialState = {
  error: string | null
  isLoading: boolean
  institutions: Institution[]
  selectedInstitution: Institution
  representative: Representative | null
  students: Student[]
  isLoadingUpdate: boolean
}
